// extracted by mini-css-extract-plugin
module.exports = {"container":"_b67079f","header":"_8b98455","content":"_e87b22f","block":"_4839f32","title":"_8f9f963"};